import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-edge',
  templateUrl: './no-edge.component.html',
  styleUrls: ['./no-edge.component.scss']
})
export class NoEdgeComponent {

    isEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    constructor() { }

}
